
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
	import UploadImg from '@/components/upload-img.vue';
	import Dialog from '@/components/dialog.vue';
  import {
    getSearchDate,
    nextDay
  } from "@/utils"
  import {
    defaultHeader
  } from "@/utils/config"
  import {
    memberCommissionImportRecordmemberCommissionImportRecordPageInit,
    memberCommissionImportRecordmemberCommissionImportRecordData,
    memberCommissionImportRecordmemberCommissionImport
  }from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate,
      UploadImg,
			'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private radioType = 1
    private radioList = [
      {value:1,label:'导入记录'},
      {value:2,label:'导入数据明细'},
    ]
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private importShow = false
    private importloading = false
    private filename = ''
    private filelist = []
    private tipshow = false
    private filterTime2 = ''
    private keywords = ''
    private record = ''
    private defaultheader = defaultHeader

    private mounted () {
      this.init()
      this.gettablelist()
    }



    private exportfile(row){
      let url = location.origin + '/pc/memberCommissionImportRecord/memberCommissionImportRecordResultExport?RecordId='+row.Id
      window.open(url)
    }
    private closetips(){
      this.tipshow = false
      this.importShow = false
    }
    private async confirmexport(){
      if(!this.filelist||!this.filelist.length){
        this.$message.error('请选择文件上传')
        return
      }
      try{
        this.importloading = true
        let res = await memberCommissionImportRecordmemberCommissionImport({
          ExcelFilePath:this.filelist[0],
          ExcelFileName:this.filename
        })
        if(res.IsSuccess){
          this.tipshow = true
          this.importShow = false
          this.gettablelist()
        }
      }finally{
        this.importloading = false
      }
    }
    private uploadSuc(file,name){
      this.filelist = file
      this.filename = name
    }
    private init(){
      let year = new Date().getFullYear()
      this.filterTime = [year+'-01-01',getSearchDate(2)[0]].join('/')
      this.filterTime2 = [year+'-01-01',getSearchDate(2)[0]].join('/')
    }
    private importfile(){
      this.filelist = []
      this.filename = ''
      this.importShow = true
    }
    private changeType(e){
      this.doSearch()
    }
    private changePage(e){
      this.pageNo = e
      if(this.radioType==1){
        this.gettablelist()
      }else{
        this.gettablelist2()
      }
    }
    private doSearch(){
      this.pageNo = 1
      if(this.radioType==1){
        this.gettablelist()
      }else{
        this.gettablelist2()
      }
    }
    private clearSearch(){
      let year = new Date().getFullYear()
      if(this.radioType==1){
        this.filterTime = [year+'-01-01',getSearchDate(2)[0]].join('/')
      }else{
        this.keywords = ''
        this.record = ''
        this.filterTime2 = [year+'-01-01',getSearchDate(2)[0]].join('/')
      }
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.filterTime){
          let t = this.filterTime.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res:any = await memberCommissionImportRecordmemberCommissionImportRecordPageInit(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist2(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          RecordId:this.record,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.filterTime2){
          let t = this.filterTime2.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res:any = await memberCommissionImportRecordmemberCommissionImportRecordData(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
